import React, { Fragment, useEffect, useState } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { isEmpty } from 'lodash-es';
import {
  Heading2,
  FlexBox,
  Heading3,
} from '@docon/docon-ui-library';
import {
  MorningIcon,
  AfternoonIcon,
  EveningIcon,
  NightIcon,
} from 'shared/icons/';
import { processNextAvailableSlots } from 'utils';
import { colors } from 'utilities/colorConfig';
import { SlotsContainer } from 'shared';
import { cleverTapAnl } from 'utilities';
import { EventAppointmentDateSelect } from 'utilities/clevertapEvent';

const bucketKeys = ['morning', 'afternoon', 'evening', 'night'];
export enum EIcon {
  morning = MorningIcon,
  afternoon = AfternoonIcon,
  evening = EveningIcon,
  night = NightIcon,
}

const Heading = styled(FlexBox)`
  width: 100%;
  font-weight: 600;
  gap: 0 12px;
  flex: 0 0 auto;
  align-items: center;
  text-transform: capitalize;
  color: ${colors.primaryColor};
`;

const Root = styled(FlexBox)`
  width: 100%;
  margin: 8px 0;
  flex-direction: column;
  gap: 12px;
  overflow: auto;
`;

function Slots({
  isReschedule,
  dateChangeTrigger,
  appointment,
  onlineSchedule = {},
  selectedDate,
  clinic = {},
  doctor = {},
  onSlotClick,
  ...props
}: any) {
  const [slotBuckets, setSlotBuckets] = useState({
    morning: [],
    afternoon: [],
    evening: [],
    night: [],
    isProcessed: false,
  });

  function getSlotBucket(slot: { startTime: number; shift: { [x: string]: boolean; }; }) {
    if (slot.startTime >= 0 && slot.startTime < 720) {
      return 'morning';
    } else if (slot.startTime >= 720 && slot.startTime < 960) {
      return 'afternoon';
    } else if (slot.startTime >= 960 && slot.startTime < 1200) {
      return 'evening';
    } else {
      return 'night';
    }
  }

  useEffect(() => {
    if (onlineSchedule.date !== moment(selectedDate).format('YYYY-MM-DD')) return;

    const slotBuckets: any = {
      morning: [],
      afternoon: [],
      evening: [],
      night: [],
    };

    const slotTypeCount: any = {
      vc: 0,
      ic: 0,
    };

    const { slots }: any = processNextAvailableSlots({
      shifts: onlineSchedule?.shifts, date: selectedDate, doctor,
      includeWalkin: true,
    });

    slots.forEach((processedSlots: any) => (
      processedSlots.forEach((slot: any) => {
        if (isReschedule && (appointment.isTeleConsult == slot.teleConsult) || !isReschedule) {
          if (!slot.type) {
            slot.teleConsult ? slotTypeCount.vc++ : slotTypeCount.ic++;
          }
          const bucket = getSlotBucket(slot);
          slotBuckets[bucket].push(slot);
        }
      })
    ));

    slotBuckets.isProcessed = true;
    if (dateChangeTrigger)
      triggerAppointmentDateSelectEvent(slotTypeCount);
    setSlotBuckets(slotBuckets);
  }, [onlineSchedule]);

  function triggerAppointmentDateSelectEvent({ vc, ic }: { vc: number; ic: number }) {
    cleverTapAnl.event({
      event_name: 'appointment_date_select',
      event: {
        page_name: 'appointment_schedule',
        doctor_id: doctor.doctorID,
        appointment_date: moment(selectedDate).format('YYYY-MM-DD'),
        calendar_picker_flag: dateChangeTrigger == 'calendar',
        vc_slots_available_count: vc,
        slot_available_count: vc + ic,
        ic_slots_available_count: ic,
      },
    } as EventAppointmentDateSelect);
  }

  function renderContent() {
    if (!slotBuckets.isProcessed) return null;

    let hasAvailableSlots = false;
    let rankInitialCount = 0;

    const node = bucketKeys.map((bucket: string): any => {
      const slots = slotBuckets[bucket];
      if (isEmpty(slots)) return null;

      hasAvailableSlots = true;
      rankInitialCount += slots.length;
      const Icon = EIcon[bucket];
      return (
        <Fragment key={bucket}>
          <Heading>
            <Icon width={30} />
            <Heading2 title={bucket} />
          </Heading>

          <SlotsContainer
            slots={slots}
            rankInitialCount={rankInitialCount - slots.length}
            clinic={clinic}
            onClick={onSlotClick}
          />
        </Fragment>
      );
    });

    if (hasAvailableSlots) return node;

    return <Heading3 m='20% auto' title={'No slots available for this day'} />;
  }

  return (
    <Root {...props}>
      {renderContent()}
    </Root>
  );
}

export { Heading };
export default styled(Slots)``;